module.exports = __webpack_public_path__ + "static/02-b7e49e8d35fa181fa6c4c4858f93713d.jpg";